// --------------------------------------------------------------
// Created On: 2025-11-05
// Author: Marco Serrano
//
// Last Modified: 2025-11-05
// Modified By: Marco Serrano
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import getPaintColorId from "./getPaintColorId";

// Function to prepare the cart items for the quote post request.
export default function formatCartItemsForQuote(cartItems: CartItem[], paintColors: PaintColor[]): QuoteCartItemPost[] {
  const quoteCartItems: QuoteCartItemPost[] = [];
  cartItems.forEach((cartItem) => {
    quoteCartItems.push({
      partId: cartItem.partId,
      partNumber: cartItem.partNumber,
      quantity: cartItem.quantity,
      paintColorId: getPaintColorId(paintColors, cartItem.paintColorId),
      impellerTrim: cartItem.impellerTrim,
      impellerAngle: cartItem.impellerAngle,
      price: cartItem.price ? cartItem.price : 0,
      description: cartItem.name,
    });
  });
  return quoteCartItems;
}

interface CartItem {
  cartItemId: number;
  name: string;
  partId: number;
  partNumber: string;
  paintColorId: number | null;
  quantity: string;
  quantityIsValid: boolean;
  units: string;
  price: number | null;
  weight: number | null;
  impellerTrim: string | null;
  impellerTrimIsValid: boolean;
  impellerAngle: string | null;
  impellerAngleIsValid: boolean;
  dateAvailable: string | null;
  isPaintable: boolean;
}

interface QuoteCartItemPost {
  partId: number;
  price: number;
  description: string;
  partNumber: string;
  paintColorId: number | null;
  quantity: string;
  impellerTrim: string | null;
  impellerAngle: string | null;
  needBy?: string | null;
  shipBy?: string | null;
}

interface PaintColor {
  paintColorId: number;
  hexCode: string;
  name: string;
}
